"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawAll = exports.getAt = exports.setPos = exports.kill = exports.killAll = exports.create = void 0;
var entitiesUtils_sidecar_1 = require("../../../entities/entitiesUtils-sidecar");
var sprites_sidecar_1 = require("../../../sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("../../../sprites/spritesUtil-sidecar");
var rogueMaps_1 = require("../map/rogueMaps");
var rogueMaps_sidecar_1 = require("../map/rogueMaps-sidecar");
var rogueDef_sidecar_1 = require("../rogueDef-sidecar");
var rogueLayers_sidecar_1 = require("../scene/rogueLayers-sidecar");
var _objs = [];
var create = function () {
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(rogueLayers_sidecar_1.rogueLayers.getLayers().dungeonFeatures, sprites_sidecar_1.sprites.rogue22[0]);
    image.scale = rogueDef_sidecar_1.rogueDef.scale;
    var c = {
        x: 0,
        y: 0,
        char: '>',
        frames: sprites_sidecar_1.sprites.rogue22,
        image: image,
        isDead: false,
    };
    _objs.push(c);
    return c;
};
exports.create = create;
var killAll = function () {
    _objs.forEach(function (c) {
        (0, exports.kill)(c);
    });
    cleanup();
};
exports.killAll = killAll;
var cleanup = function () {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(_objs, function (c) {
        c.image.destroy();
    });
};
var kill = function (c) {
    c.isDead = true;
    c.image.visible = false;
};
exports.kill = kill;
var setPos = function (c, x, y) {
    c.x = x;
    c.y = y;
};
exports.setPos = setPos;
var getAt = function (x, y) {
    return _objs.find(function (c) { return c.x === x && c.y === y; }) || null;
};
exports.getAt = getAt;
var drawAll = function () {
    // let game = game2.getGame()
    var map = rogueMaps_sidecar_1.rogueMaps.getCurrentMap();
    if (!map) {
        return;
    }
    cleanup();
    _objs.forEach(function (c) {
        c.image.x = c.x * rogueDef_sidecar_1.rogueDef.sizeX;
        c.image.y = c.y * rogueDef_sidecar_1.rogueDef.sizeY;
        var t = rogueMaps_sidecar_1.rogueMaps.getTile(map, c.x, c.y);
        if (t) {
            if (t.eVision === rogueMaps_1.EVision.None) {
                c.image.visible = false;
            }
            else {
                c.image.visible = true;
            }
        }
    });
};
exports.drawAll = drawAll;
